export default "__VITE_ASSET__SN8oFufp__"